// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__OhAbM","covid":"App_covid__27zlo","footer":"App_footer__3euks"};